## Quartz

The Quartz plugin offers functionality for viewing and managing [Quartz](http://www.quartz-scheduler.org/) schedulers.

### Scheduler

Here you can see the scheduler its state and statistics. You can also pause and resume a scheduler.

### Jobs

Jobs lists and allows you to see information about job definitions.

### Triggers

Here you see the existing triggers in the selected scheduler and their state, including previous and next fire times. Individual triggers can be paused and resumed.
You can also edit some properties of a scheduler or make it fire instantly regardless of the scheduler.
